import { Location } from '@angular/common';
import { Component, Input, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';

@Component({
    selector: 'status-view',
    templateUrl: './status-view.component.html',
    styleUrls: ['./status-view.component.scss'],
    standalone: false
})
export class StatusViewComponent implements OnInit {

  constructor(private routerParam:ActivatedRoute) { 
    
  }

  @Input() codition:string = '0=0';
  @Input() nodata:boolean = true;
  ngOnInit(): void {
      
    if ( window.history.state ){
      const data:Object  = window.history.state;
      
      if ( Object.keys(data).findIndex(x=>x=='condition') > -1 ){
          this.codition = data['condition'];
          this.nodata = data['nodata'];
      }
      
    }

  }

}
